module.exports = __webpack_public_path__ + "static/img/img_sanatorium.b5ec048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare/img_sanatorium.png
// module id = wzOk
// module chunks = 0